import React, { useState } from "react";
import moment from "moment";

const validateRecord = (record) => {
  let error = false;
  let errorMessage = "";

  if (!error && !record.originAirportCode) {
    error = true;
    errorMessage = "'Origin Airport Code' is required";
  }
  if (!error && !record.destinationAirportCode) {
    error = true;
    errorMessage = "'Destination Airport Code' is required";
  }
  if (!error && record.transportType === 'PRIMARY' && !record.alternateAirportCode) {
    error = true;
    errorMessage = "'Alternate Airport Code' is required";
  }
  if (!error && !record.transportType) {
    error = true;
    errorMessage = "'Transport Type' is required";
  }
  if (!error && record.transportType === 'PRIMARY' && (!record.airlineCode || !record.flightNo)) {
    error = true;
    errorMessage = "'Flight No' is required";
  }
  if (!error && !moment(record.flightDate).isValid()) {
    error = true;
    errorMessage = "'Flight Date' does not contain a valid date";
  }
  if (!error && !moment(record.contractedDepartureTimeUTC).isValid()) {
    error = true;
    errorMessage = "Please enter a valid 'Departure' time";
  } 
   if (!error && !moment(record.contractedArrivalTimeUTC).isValid()) {
    error = true;
    errorMessage = "Please enter a valid 'Arrival' time";
  } 

  const departureMoment = moment.utc(record.contractedDepartureTimeUTC);
  const arrivalMoment = moment.utc(record.contractedArrivalTimeUTC);
  const diff = arrivalMoment.diff(departureMoment, 'minutes');

  if (!error && diff < 30) {
    error = true;
    errorMessage = "'Duration' time is too short";
  } 

  if (!error && !record.legType) {
    error = true;
    errorMessage = "'Leg Type' is required";
  }

  if (!error && record.transportType === 'PRIMARY' && !record.aircraftId) {
    error = true;
    errorMessage = "'Aircraft Id' is required";
  }

  return {
    error,
    errorMessage
  }
}
const TripLegsValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  const { error, errorMessage } = validateRecord(record);

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default TripLegsValidator;
export { validateRecord };
